import { Component } from '@angular/core';

@Component({
  selector: 'app-account-chat',
  templateUrl: './account-chat.component.html',
  styleUrls: ['./account-chat.component.css']
})
export class AccountChatComponent {
  // Set Topbar Option
  Menuoption = 'center';
  Settingicon = true
  /**
   * nav light class add
   */
  navClass = 'nav-light';
}
